import { Close } from '@mui/icons-material'
import { Button, IconButton, OutlinedInput, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useForm } from 'react-hook-form';

import styles from "./Privilege.module.css";
import { useSelector } from 'react-redux';
import { useGetPrivilegeByIdQuery, useUpdatePrivilegeMutation } from '../../Store/Services/privilegeService';


const schema = yup.object({
    privilegeName:yup.string().required(""),
}).required();

const EditPrivilege = ({ handleClose }) => {

    const privilege = useSelector((state) => state.privilege);

    const { data: prevDetails, isSuccess: prevSuccess, isLoading: prevLoading } = useGetPrivilegeByIdQuery(privilege.selectedPrivilege);

    const {register, handleSubmit, reset, formState: { errors }} = useForm({
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        if(prevSuccess) {
            reset({
                privilegeName: prevDetails?.privilegeName,
            })
        }
    }, [prevDetails])

    const [updatePrivilege] = useUpdatePrivilegeMutation();

    const onSubmit = async (data) => {
        const dataSet = {
            ...data,
            privilegeId: privilege.selectedPrivilege
        }
        try {
            const respond = await updatePrivilege(dataSet).unwrap();
            // toast.success("Privilege successfully added!");
        } catch (err) {
            console.error("Failed to save the Privilege: ", err);
            toast.error("Erorr, something went wrong!");
        }
        handleClose();
    };

    return (
        <div>
            <div className={styles.headingContainer}>
                <Typography fontWeight={600} variant={"h6"}>
                    Edit Privilege
                </Typography>
                <IconButton className={styles.closeButton} onClick={handleClose} aria-label="Close">
                    <Close />
                </IconButton>
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={styles.formItem}>
                    <label className={styles.formLabel}>Name:</label>
                    {errors.privilegeName && errors.privilegeName.type === "required" && <span className={styles.validation} > *</span>}
                    <OutlinedInput
                        {...register("privilegeName")}
                        className={styles.formInput}
                        placeholder="Enter Name"
                        size="small"
                        fullWidth
                    />
                </div>

                {/* Submit Button */}
                <div className={styles.buttonContainer}>
                    <Button type="submit" className={styles.submitButton} variant="contained" aria-label="Save">Save</Button>
                </div>
            </form>
        </div>
    )
}

export default EditPrivilege